var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dashboard-text"
  }, [_c('img', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "src": require("../../../assets/oa/approve-back.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeBackTwo()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("发起审批")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "dashboard-contentTwo",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('VFormReader', {
    ref: "vFormRef",
    staticClass: "form",
    attrs: {
      "form-json": _vm.formJson,
      "form-data": _vm.formData,
      "option-data": _vm.optionData
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dashboard-contentTwo",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "60px",
      "margin-left": "20px",
      "padding-bottom": "30px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("提交")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核",
      "visible": _vm.spShow,
      "width": "35%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.spShow = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.dataObject.ejectType == 23) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "line-height": "50px"
    }
  }, [_c('div', [_vm._v("预算总金额:" + _vm._s(_vm.dataObject.annual))]), _vm._v(" "), _c('div', [_vm._v("已执行金额:" + _vm._s(_vm.dataObject.budget))]), _vm._v(" "), _c('div', [_vm._v("本次执行金额:" + _vm._s(_vm.dataObject.amount_money))])]) : _vm._e(), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "data": _vm.examineDetailsList,
      "tooltip-effect": "dark",
      "height": "300"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "node",
      "label": "节点",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role_name",
      "label": "岗位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "label": "审核人",
      "align": "center"
    }
  })], 1), _vm._v(" "), (_vm.dataObject.isSubmit) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.findTwo()
      }
    }
  }, [_vm._v("确定")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122c4578","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oa/approve/expenseReimburse.vue
// module id = null
// module chunks = 